import styles from '../../accounts/main/styles';

export default styles;
